import { Box } from "@mui/material";
import moment from "moment";
import { getCellStyle } from "../../Utils/DecideColor";
import { getStatusLabel } from "../../Utils/DecideStatus";
import { formatCellValue ,formatDateForDisplay} from "../../Utils/UtilityFunctions";
import StatusBadge from "../../Customers/StatusBadge";
export const BillsColumns = (docTableMockData) => {
    const columns = [
        {
            accessorKey: 'billId',
            header: 'Invoice ID',
            size: 150,
            // Cell: ({ cell }) => (
            //     <Box
            //         sx={(theme) => (cell.getValue() ? {
            //             color: '#3478F1',

            //         } : {})}
            //     >
            //         {cell.getValue()}
            //     </Box>
            // )
        },
        {
            accessorKey: 'startTime',
            header: 'Start Date',
            size: 150,
            Cell: ({ cell }) => (
                <Box>
                    {moment(cell.getValue()).format("DD MMM YYYY")}
                </Box>
            )
        },
        {
            accessorKey: 'endTime',
            header: 'End Date',
            size: 150,

            Cell: ({ cell }) => (
                <Box>
                    {moment(cell.getValue()).format("DD MMM YYYY")}
                </Box>
            )
        },
        {
            accessorKey: 'dueAmount',
            header: 'Balance Due',
            Cell: ({ cell }) => formatCellValue(cell.getValue()),
            size: 150,

        },
        {
            accessorKey: 'taxAmount',
            header: 'Amount',
           Cell: ({ cell }) => formatCellValue(cell.getValue()),
            size: 150,

        },
        {
  accessorKey: 'status',
  header: 'Status',
  size: 150,
  Cell: ({ cell }) => (
    <StatusBadge value={cell.getValue()} />
  ),
}
        
    ]
    return columns
}